import { render, staticRenderFns } from "./ProductEditorDialog.vue?vue&type=template&id=245df848"
import script from "./ProductEditorDialog.vue?vue&type=script&lang=js"
export * from "./ProductEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductEditorDialog.vue?vue&type=style&index=0&id=245df848&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports